import { CustomLoader } from "./components/CustomLoader/CustomLoader";
import { useDispatch, useSelector } from "react-redux";
import { hideSimpleModalAction } from "./redux/actions";
import React, { Suspense, useEffect } from "react";
import { CustomModal } from "./components/CustomModal/CustomModal";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import history from "./history";
import { ErrorPage } from "./view/404.jsx";
import { Navigate } from "react-router";
import MainPage from "./view/MainPage";
import { NewPasswordPage } from "./view/NewPasswordPage/NewPasswordPage";
import PrettyUrlPage from "./view/PrettyUrlPage.js";
import { Helmet } from "react-helmet";

function App() {
  const dispatch = useDispatch();
  const loader = useSelector((state) => state.helpers.loader);
  const simpleModal = useSelector((state) => state.helpers.simpleModal);
  const favicon = useSelector((state) => state.profile.favicon);
  const space = useSelector((state) => state.profile.space);
  const [title, setTitle] = React.useState("AkrotonX");
  const [description, setDescription] = React.useState("Showcase by");
  const [faviconLink, setFaviconLink] = React.useState("/favicon.ico");

  const handleClose = () => {
    dispatch(hideSimpleModalAction());
  };

  useEffect(() => {
    setTitle(space?.name ?? "AkrotonX");
    setFaviconLink(favicon);
    setDescription(`Showcase by ${space?.configs?.title ?? "AkrotonX"}`);
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = favicon;
    // document.title = space?.name ?? "";
  }, [favicon, space?.name, space?.configs?.title]);
  // !TODO

  // console.log("faviconLink", faviconLink);
  // console.log("space", space);
  // console.log("title", space?.title);
  return (
    <Suspense fallback={<CustomLoader />}>
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={faviconLink} />
        
        <meta property="og:type" content="website" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={faviconLink} />
      </ Helmet>
      {loader && <CustomLoader />}
      {simpleModal.isModal && simpleModal.title !== "Error" && (
        <div className="error-modal">
          <CustomModal
            title={simpleModal.title}
            close={handleClose}
            isCancelBtn={false}
            submitBtn="OK"
            submit={handleClose}
          >
            <div className="error-modal__text">{simpleModal.text}</div>
          </CustomModal>
        </div>
      )}

      <BrowserRouter history={history}>
        <Routes>
          <Route path="/" element={<Navigate to="/showcase" replace />} />
          <Route path="/showcase/:id" element={<MainPage />} />
          <Route path="/auth/verify/*" element={<NewPasswordPage />} />
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<PrettyUrlPage />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
